import { Availability, MenuItem } from '@core/models';
import { JuvoTrackSession } from '@core/domain/local-channel';
import { CartStateFactory } from './cart-state.factory';
import {
	CartItemUpsertContext,
	CartItemUpsertEffectInput,
	CartItemAvailabilityContext,
	CartStockUpdateContext,
	CartStockUpdateEffectInput,
} from './interfaces';

export class CartStateProcessor {
	constructor(private readonly factory: CartStateFactory) {}

	upsertCartItemFromEffect(input: CartItemUpsertEffectInput): MenuItem[] {
		const initialContext: CartItemUpsertContext = {
			cartItems: input.cartItems,
			item: input.action.item,
			storeSlug: input.storeSlug,
			mergedCartItems: [],
			positiveQuantityCartItems: [],
			updatedCartItems: [],
		};
		return this.factory
			.createItemUpsertRules()
			.reduce<CartItemUpsertContext>((context, rule) => rule(context), initialContext)
			.updatedCartItems;
	}

	updateStockFromEffect(input: CartStockUpdateEffectInput): {
		productList: MenuItem[];
		cartItems: MenuItem[];
	} {
		const initialContext: CartStockUpdateContext = {
			updateProduct: input.action.updateProduct,
			productList: input.productList,
			cartItems: input.cartItems,
			updatedProductList: [],
			availableProductList: [],
			stockAdjustedCartItems: [],
			quantityLimitedCartItems: [],
			positiveQuantityCartItems: [],
			synchronizedCartItems: [],
			updatedCartItems: [],
		};
		const result = this.factory.createStockUpdateRules().reduce<CartStockUpdateContext>(
			(context, rule) => rule(context),
			initialContext
		);
		return {
			productList: result.availableProductList,
			cartItems: result.updatedCartItems,
		};
	}

	existProductOutStock(
		cartItems: MenuItem[],
		availabilityList: Availability[] | null,
		localChannelSession: JuvoTrackSession | null,
		now = new Date()
	): string[] {
		const initialContext: CartItemAvailabilityContext = {
			cartItems,
			availabilityList,
			localChannelSession,
			now,
			unavailableItems: [],
		};

		return this.factory
			.createAvailabilityRules()
			.reduce<CartItemAvailabilityContext>((context, rule) => rule(context), initialContext)
			.unavailableItems.map(item => item.nombre);
	}

}

export const cartStateProcessor = new CartStateProcessor(new CartStateFactory());
